export default "__VITE_ASSET__Dt0$FwyY__"